import { render } from "./elTable.vue?vue&type=template&id=53ade90c&scoped=true"
import script from "./elTable.vue?vue&type=script&lang=js"
export * from "./elTable.vue?vue&type=script&lang=js"

import "./elTable.vue?vue&type=style&index=0&id=53ade90c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ade90c"]])

export default __exports__